"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteJobPayload = exports.JobIdPayload = exports.CreatedJob = exports.JobProgressBase = exports.JobBase = exports.Summary = exports.TargetSelectionMode = exports.JobTrigger = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../../json"));
const Job = __importStar(require("../../../../../job"));
const NAMESPACE = 'Culligan.Api.V1.Admin.Device.Schema';
exports.JobTrigger = effect_1.Schema.Literal('scheduler', 'onDemand').annotations({
    identifier: `${NAMESPACE}.JobTrigger`,
});
exports.TargetSelectionMode = effect_1.Schema.Literal('deviceGroup', 'filter').annotations({
    identifier: `${NAMESPACE}.TargetSelectionMode`,
});
exports.Summary = effect_1.Schema.Record({ key: effect_1.Schema.String, value: effect_1.Schema.Int }).annotations({
    identifier: `${NAMESPACE}.Summary`,
    description: 'Per-status target counters, e.g. { succeeded: 0, failed: 0 }.',
});
exports.JobBase = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    model: effect_1.Schema.NullOr(effect_1.Schema.String),
    enabled: effect_1.Schema.Boolean,
    status: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'v1 values: loading, queued, running, coolDown, waiting, paused, completed, failed, ' +
            'canceled. V2 jobs share this collection and may carry other values (succeeded, ' +
            'temporaryError, delivered, ...).',
    }),
    attempts: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    trigger: exports.JobTrigger,
    targetSelectionMode: exports.TargetSelectionMode,
    scheduleParams: effect_1.Schema.NullOr(Job.ScheduleParams),
    summary: exports.Summary,
    notificationTriggers: effect_1.Schema.Array(effect_1.Schema.Literal('completed', 'failed')),
    createdAt: effect_1.Schema.String,
    updatedAt: effect_1.Schema.String,
    endedAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    scheduleId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    targetFilterId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    targetFilterParams: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), {
        exact: true,
    }).annotations({
        description: 'Inline device search filter (same params as device search), e.g. { serialNumbers: [...] }.',
    }),
    targetUpdatePolicy: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Job.TargetUpdatePolicy), { exact: true }),
    userId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    retryPolicy: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Job.RetryPolicy), { exact: true }),
    retryInterval: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Int), { exact: true }),
    maxAttempts: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Int), { exact: true }),
    startAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    stopAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    timezone: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.JobBase`,
});
exports.JobProgressBase = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    jobId: effect_1.Schema.NonEmptyString,
    serialNumber: effect_1.Schema.NonEmptyString,
    status: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Per-target delivery status.',
    }),
    attempts: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    createdAt: effect_1.Schema.String,
    updatedAt: effect_1.Schema.String,
    lastAttemptAt: effect_1.Schema.NullOr(effect_1.Schema.String),
    deliveredAt: effect_1.Schema.NullOr(effect_1.Schema.String),
    completedAt: effect_1.Schema.NullOr(effect_1.Schema.String),
    log: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.JobProgressBase`,
});
exports.CreatedJob = effect_1.Schema.Struct({ item: effect_1.Schema.Struct({ id: effect_1.Schema.NonEmptyString }) }).annotations({
    identifier: `${NAMESPACE}.CreatedJob`,
});
exports.JobIdPayload = effect_1.Schema.Struct({ id: effect_1.Schema.NonEmptyString }).annotations({
    identifier: `${NAMESPACE}.JobIdPayload`,
});
exports.DeleteJobPayload = effect_1.Schema.Struct({
    id: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.DeleteJobPayload`,
});
//# sourceMappingURL=schema.js.map